<mat-card appearance="outlined" class="tos-mat-card">
    <mat-card-content *transloco="let t">
        <div [innerHtml]="t('Tos.Content')"></div>
    </mat-card-content>
</mat-card>
